import { getValidationResolver, useForm } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';
import { MAX_LENGTH_TEXT } from '@/common/constants';
import { ICreateDocumentAggregatorDtoDocumentTypeEnum } from '@/dtos';

export const DESCRIPTION_MAX_LENGTH = 500;

export enum LettersOfMedicalNecessityFormField {
  type = 'type',
  name = 'name',
  description = 'description',
  validDates = 'validDates',
}

export interface LettersOfMedicalNecessityForm {
  [LettersOfMedicalNecessityFormField.type]: string;
  [LettersOfMedicalNecessityFormField.name]: string;
  [LettersOfMedicalNecessityFormField.description]: string;
  [LettersOfMedicalNecessityFormField.validDates]: Date[];
}

interface Props {
  isViewMode?: boolean;
}

const useLettersOfMedicalNecessityForm = ({ isViewMode = false }: Props = {}) => {
  const validationSchema = isViewMode
    ? {}
    : {
        [LettersOfMedicalNecessityFormField.type]: VALIDATORS.REQUIRED_STRING,
        [LettersOfMedicalNecessityFormField.name]: VALIDATORS.REQUIRED_STRING,
        [LettersOfMedicalNecessityFormField.description]: VALIDATORS.STRING.max(
          500,
          MAX_LENGTH_TEXT(DESCRIPTION_MAX_LENGTH)
        ),
      };

  const methods = useForm<LettersOfMedicalNecessityForm>({
    resolver: getValidationResolver(validationSchema),
    defaultValues: {
      [LettersOfMedicalNecessityFormField.type]:
        ICreateDocumentAggregatorDtoDocumentTypeEnum.LETTER_OF_MEDICAL_NECESSITY,
    },
  });

  return { methods };
};

export default useLettersOfMedicalNecessityForm;
